export const COUNTRY_CZ = 1;

const countries = [
	{ value: 65, label: 'Afghánistán' },
	{ value: 469, label: 'Ålandy' },
	{ value: 66, label: 'Albánie' },
	{ value: 67, label: 'Alžírsko' },
	{ value: 468, label: 'Americká Samoa' },
	{ value: 470, label: 'Americké Panenské ostrovy' },
	{ value: 68, label: 'Andorra' },
	{ value: 69, label: 'Angola' },
	{ value: 474, label: 'Anguilla' },
	{ value: 475, label: 'Antarktida' },
	{ value: 70, label: 'Antigua a Barbuda' },
	{ value: 63, label: 'Argentina' },
	{ value: 71, label: 'Arménie' },
	{ value: 472, label: 'Aruba' },
	{ value: 57, label: 'Austrálie' },
	{ value: 72, label: 'Ázerbájdžán' },
	{ value: 281, label: 'Bahamy' },
	{ value: 282, label: 'Bahrajn' },
	{ value: 283, label: 'Bangladéš' },
	{ value: 284, label: 'Barbados' },
	{ value: 13, label: 'Belgie' },
	{ value: 286, label: 'Belize' },
	{ value: 30, label: 'Bělorusko' },
	{ value: 287, label: 'Benin' },
	{ value: 477, label: 'Bermudy' },
	{ value: 289, label: 'Bhútán' },
	{ value: 290, label: 'Bolívie' },
	{ value: 473, label: 'Bonaire, Saint Eustatius and Saba' },
	{ value: 45, label: 'Bosna a Hercegovina' },
	{ value: 292, label: 'Botswana' },
	{ value: 478, label: 'Bouvetův ostrov' },
	{ value: 46, label: 'Brazílie' },
	{ value: 471, label: 'Britské Panenské ostrovy' },
	{ value: 495, label: 'Britské indickooceánské území' },
	{ value: 294, label: 'Brunej' },
	{ value: 38, label: 'Bulharsko' },
	{ value: 296, label: 'Burkina Faso' },
	{ value: 297, label: 'Burundi' },
	{ value: 299, label: 'Čad' },
	{ value: 59, label: 'Černá Hora' },
	{ value: COUNTRY_CZ, label: 'Česká republika' },
	{ value: 328, label: 'Chile' },
	{ value: 44, label: 'Chorvatsko' },
	{ value: 27, label: 'Čína' },
	{ value: 298, label: 'Cookovy ostrovy' },
	{ value: 480, label: 'Curaçao' },
	{ value: 16, label: 'Dánsko' },
	{ value: 304, label: 'Demokratická republika Kongo' },
	{ value: 305, label: 'Dominika' },
	{ value: 306, label: 'Dominikánská republika' },
	{ value: 307, label: 'Džibutsko' },
	{ value: 308, label: 'Egypt' },
	{ value: 309, label: 'Ekvádor' },
	{ value: 310, label: 'Eritrea' },
	{ value: 8, label: 'Estonsko' },
	{ value: 312, label: 'Etiopie' },
	{ value: 484, label: 'Faerské ostrovy' },
	{ value: 483, label: 'Falklandy (Malvíny)' },
	{ value: 313, label: 'Fidži' },
	{ value: 28, label: 'Filipíny' },
	{ value: 5, label: 'Finsko' },
	{ value: 25, label: 'Francie' },
	{ value: 485, label: 'Francouzská Guyana' },
	{ value: 505, label: 'Francouzská Polynésie' },
	{ value: 514, label: 'Francouzská jižní a antarktická území' },
	{ value: 317, label: 'Gabon' },
	{ value: 318, label: 'Gambie' },
	{ value: 319, label: 'Ghana' },
	{ value: 487, label: 'Gibraltar' },
	{ value: 320, label: 'Grenada' },
	{ value: 488, label: 'Grónsko' },
	{ value: 321, label: 'Gruzie' },
	{ value: 489, label: 'Guadeloupe' },
	{ value: 491, label: 'Guam' },
	{ value: 322, label: 'Guatemala' },
	{ value: 486, label: 'Guernsey' },
	{ value: 323, label: 'Guinea' },
	{ value: 324, label: 'Guinea-Bissau' },
	{ value: 325, label: 'Guyana' },
	{ value: 326, label: 'Haiti' },
	{ value: 493, label: 'Heardův ostrov a McDonaldovy ostrovy' },
	{ value: 327, label: 'Honduras' },
	{ value: 492, label: 'Hongkong' },
	{ value: 33, label: 'Indie' },
	{ value: 41, label: 'Indonésie' },
	{ value: 61, label: 'Irák' },
	{ value: 62, label: 'Írán' },
	{ value: 17, label: 'Irsko' },
	{ value: 335, label: 'Island' },
	{ value: 15, label: 'Itálie' },
	{ value: 22, label: 'Izrael' },
	{ value: 338, label: 'Jamajka' },
	{ value: 58, label: 'Japonsko' },
	{ value: 340, label: 'Jemen' },
	{ value: 496, label: 'Jersey' },
	{ value: 341, label: 'Jihoafrická republika' },
	{ value: 490, label: 'Jižní Georgie a Jižní Sandwichovy ostrovy' },
	{ value: 51, label: 'Jižní Korea' },
	{ value: 343, label: 'Jižní Súdán' },
	{ value: 344, label: 'Jordánsko' },
	{ value: 497, label: 'Kajmanské ostrovy' },
	{ value: 345, label: 'Kambodža' },
	{ value: 346, label: 'Kamerun' },
	{ value: 54, label: 'Kanada' },
	{ value: 348, label: 'Kapverdy' },
	{ value: 349, label: 'Katar' },
	{ value: 350, label: 'Kazachstán' },
	{ value: 49, label: 'Keňa' },
	{ value: 352, label: 'Kiribati' },
	{ value: 479, label: 'Kokosové ostrovy' },
	{ value: 353, label: 'Kolumbie' },
	{ value: 354, label: 'Komory' },
	{ value: 521, label: 'Kosovo' },
	{ value: 356, label: 'Kostarika' },
	{ value: 357, label: 'Kuba' },
	{ value: 358, label: 'Kuvajt' },
	{ value: 359, label: 'Kypr' },
	{ value: 360, label: 'Kyrgyzstán' },
	{ value: 361, label: 'Laos' },
	{ value: 362, label: 'Lesotho' },
	{ value: 363, label: 'Libanon' },
	{ value: 364, label: 'Libérie' },
	{ value: 52, label: 'Libye' },
	{ value: 26, label: 'Lichtenštejnsko' },
	{ value: 11, label: 'Litva' },
	{ value: 34, label: 'Lotyšsko' },
	{ value: 53, label: 'Lucembursko' },
	{ value: 499, label: 'Macao' },
	{ value: 370, label: 'Madagaskar' },
	{ value: 9, label: 'Maďarsko' },
	{ value: 372, label: 'Makedonie' },
	{ value: 373, label: 'Malajsie' },
	{ value: 374, label: 'Malawi' },
	{ value: 375, label: 'Maledivy' },
	{ value: 376, label: 'Mali' },
	{ value: 377, label: 'Malta' },
	{ value: 378, label: 'Maroko' },
	{ value: 379, label: 'Marshallovy ostrovy' },
	{ value: 501, label: 'Martinik' },
	{ value: 381, label: 'Mauricius' },
	{ value: 380, label: 'Mauritánie' },
	{ value: 520, label: 'Mayotte' },
	{ value: 517, label: 'Menší odlehlé ostrovy USA' },
	{ value: 29, label: 'Mexiko' },
	{ value: 383, label: 'Mikronésie' },
	{ value: 384, label: 'Moldavsko' },
	{ value: 19, label: 'Monako' },
	{ value: 386, label: 'Mongolsko' },
	{ value: 502, label: 'Montserrat' },
	{ value: 387, label: 'Mosambik' },
	{ value: 388, label: 'Myanmar' },
	{ value: 389, label: 'Namibie' },
	{ value: 390, label: 'Nauru' },
	{ value: 3, label: 'Německo' },
	{ value: 391, label: 'Nepál' },
	{ value: 393, label: 'Niger' },
	{ value: 394, label: 'Nigérie' },
	{ value: 395, label: 'Nikaragua' },
	{ value: 396, label: 'Niue' },
	{ value: 397, label: 'Nizozemsko' },
	{ value: 504, label: 'Norfolk' },
	{ value: 64, label: 'Norsko' },
	{ value: 503, label: 'Nová Kaledonie' },
	{ value: 399, label: 'Nový Zéland' },
	{ value: 400, label: 'Omán' },
	{ value: 494, label: 'Ostrov Man' },
	{ value: 401, label: 'Pákistán' },
	{ value: 402, label: 'Palau' },
	{ value: 509, label: 'Palestinská autonomie' },
	{ value: 403, label: 'Panama' },
	{ value: 404, label: 'Papua Nová Guinea' },
	{ value: 405, label: 'Paraguay' },
	{ value: 406, label: 'Peru' },
	{ value: 507, label: 'Pitcairnovy ostrovy' },
	{ value: 407, label: 'Pobřeží slonoviny' },
	{ value: 6, label: 'Polsko' },
	{ value: 508, label: 'Portoriko' },
	{ value: 12, label: 'Portugalsko' },
	{ value: 4, label: 'Rakousko' },
	{ value: 31, label: 'Řecko' },
	{ value: 355, label: 'Republika Kongo' },
	{ value: 466, label: 'Réunion' },
	{ value: 411, label: 'Rovníková Guinea' },
	{ value: 21, label: 'Rumunsko' },
	{ value: 7, label: 'Rusko' },
	{ value: 414, label: 'Rwanda' },
	{ value: 506, label: 'Saint-Pierre a Miquelon' },
	{ value: 442, label: 'Šalamounovy ostrovy' },
	{ value: 416, label: 'Salvador' },
	{ value: 417, label: 'Samoa' },
	{ value: 418, label: 'San Marino' },
	{ value: 419, label: 'Saúdská Arábie' },
	{ value: 420, label: 'Senegal' },
	{ value: 60, label: 'Severní Korea' },
	{ value: 500, label: 'Severní Mariany' },
	{ value: 422, label: 'Seychely' },
	{ value: 423, label: 'Sierra Leone' },
	{ value: 50, label: 'Singapur' },
	{ value: 425, label: 'Slovensko' },
	{ value: 39, label: 'Slovinsko' },
	{ value: 427, label: 'Somálsko' },
	{ value: 35, label: 'Španělsko' },
	{ value: 511, label: 'Špicberky a Jan Mayen' },
	{ value: 428, label: 'Spojené arabské emiráty' },
	{ value: 18, label: 'Spojené království' },
	{ value: 37, label: 'Srbsko' },
	{ value: 432, label: 'Srí Lanka' },
	{ value: 433, label: 'Středoafrická republika' },
	{ value: 435, label: 'Súdán' },
	{ value: 434, label: 'Surinam' },
	{ value: 510, label: 'Svatá Helena, Ascension a Tristan da Cunha' },
	{ value: 436, label: 'Svatá Lucie' },
	{ value: 476, label: 'Svatý Bartoloměj' },
	{ value: 437, label: 'Svatý Kryštof a Nevis' },
	{ value: 498, label: 'Svatý Martin (francouzská část)' },
	{ value: 512, label: 'Svatý Martin (nizozemská část)' },
	{ value: 438, label: 'Svatý Tomáš a Princův ostrov' },
	{ value: 439, label: 'Svatý Vincenc a Grenadiny' },
	{ value: 440, label: 'Svazijsko' },
	{ value: 47, label: 'Švédsko' },
	{ value: 23, label: 'Švýcarsko' },
	{ value: 56, label: 'Sýrie' },
	{ value: 446, label: 'Tádžikistán' },
	{ value: 447, label: 'Tanzanie' },
	{ value: 516, label: 'Tchaj-wan' },
	{ value: 448, label: 'Thajsko' },
	{ value: 449, label: 'Togo' },
	{ value: 515, label: 'Tokelau' },
	{ value: 450, label: 'Tonga' },
	{ value: 451, label: 'Trinidad a Tobago' },
	{ value: 452, label: 'Tunisko' },
	{ value: 42, label: 'Turecko' },
	{ value: 454, label: 'Turkmenistán' },
	{ value: 513, label: 'Turks a Caicos' },
	{ value: 455, label: 'Tuvalu' },
	{ value: 40, label: 'USA' },
	{ value: 456, label: 'Uganda' },
	{ value: 24, label: 'Ukrajina' },
	{ value: 458, label: 'Uruguay' },
	{ value: 459, label: 'Uzbekistán' },
	{ value: 481, label: 'Vánoční ostrov' },
	{ value: 460, label: 'Vanuatu' },
	{ value: 461, label: 'Vatikán' },
	{ value: 462, label: 'Venezuela' },
	{ value: 55, label: 'Vietnam' },
	{ value: 464, label: 'Východní Timor' },
	{ value: 518, label: 'Wallis a Futuna' },
	{ value: 465, label: 'Zambie' },
	{ value: 482, label: 'Západní Sahara' },
	{ value: 73, label: 'Zimbabwe' },
];

export function getCountryLabel(value)
{
	for (let country of countries) {
		if (country.value === value) {
			return country.label;
		}
	}

	return '';
}

export function getCountryValue(label)
{
	for (let country of countries) {
		if (country.label === label) {
			return country.value;
		}
	}

	return COUNTRY_CZ;
}


export default countries;


// WEBPACK FOOTER //
// ./src/enums/countries.js